<template>
  <div class="solution">
    <div class="banner">
      <div class="title">汽车行业解决方案</div>
      <div class="desc">
        <section>为国内外头部车企提供涵盖10种能力，4类应用场景（业务、数据、流程、能力），从内容生产</section>
        <section>到内容管理到内容分发到数据监测的全链路数字化营销解决方案</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>拥有多品牌、 多产品的车企，需要多种内容形式和渠道的内容资产，但企业设计资源有</section>
            <section>限，⽆法确保创意物料符合品牌⼀致性规范；设计师重复劳动多⼯作压⼒⼤，销售⽆法</section>
            <section>及时得到创意物料；不同渠道⼴告尺⼨多，重复性素材产出慢</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">品牌规范管理：</span>设计师将企业品牌设计规范数字化/在线化，通过锁定功能，使物料调整</section>
            <section>范围约束在品牌要求内，确保修改内容的物料符合品牌规范</section>
            <section><span>在线设计：</span>设计师完成核⼼创意物料后，销售⼈员选择物料，系统⾃动更换个⼈信息，</section>
            <section>销售部⻔⽆论何时何地，⽹⻚还是⼿机，拖拉拽傻⽠式操作，⾼效操作，产出符合品牌</section>
            <section>规范的设计</section>
             <section><span>AI设计：</span>根据分发场景和尺寸，⾃动生产内容，解放设计师双⼿，更加聚焦创意本身，</section>
            <section>告别机械化的修改操作，提升准确率</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/car/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/car/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>车企品牌增加，导致内容增多，各部⻔管理⽅式不同，内容⽆法快速引⽤；⻋企投放渠</section>
            <section>道多、内容⼴，素材检索维度少，优质素材复⽤率低；⽆法保证⼤量素材⽂件的合规</section>
            <section>性，版权到期⻛险；修改内容时，沟通成本⾼，协同难度⼤，内容素材⼈⼯审批流程慢</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">内容管理平台：</span>搭建⼤⽂件、多格式、⾼速传输的内容管理平台，通过智能标签、智能检</section>
            <section>索，帮助成员快速查找并在线编辑；⽀持外部内容⼀键导⼊导出，实现⼀站式内容共享</section>
            <section><span>内容标签体系：</span>建设智能+⾃定义+三⽅综合标签体系；通过商品标签+⽂件标签+渠道标签</section>
            <section>+效果标签等进⾏搜索，快速找到对应⽂件</section>
            <section><span>内容审核功能：</span>在⽤户素材⼊库、设计输出、媒体投放等操作时，通过智能引擎，实时检</section>
            <section>测违规内容，保障⼴告内容合规；根据组织架构或对接企业OA流程，自定义企业⼈⼯审</section>
            <section>批流程，提升审批效率</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>⻋企宣发渠道繁杂， 触达到各渠道⽤户群组费时费⼒；⻋企公域⼴告投放平台多渠道</section>
            <section>⼴，推⼴效果分析周期⻓，⼴告投放服务不标准，⽆法及时获得投放数据</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">私域内容分发：</span>对接企业内部媒体平台，⽀持各个平台多账号管理（微信公众号、头条</section>
            <section>号等），⼀键定时发布，通过严格的审核流程保障内容合规；通过API打通企业微信、</section>
            <section>钉钉、APP等，进⾏私域内容传播；分发数据回流，全⾯监控账号运营效果，诊断账号</section>
            <section>的影响⼒和健康度</section>
            <section><span>公域内容分发：</span>跨平台账号聚合管理，根据三层标签体系（AI智能标签、⾃定义标签、</section>
            <section>三⽅标签），通过定时、定向等⽅式精准投放；多渠道消息通知，账户异动及时掌握预</section>
            <section>警跨账户全局多维度数据清晰呈现，洞察数据趋势</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/car/3.png">
      </div>
        <div class="row drak">
        <img class="img" :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>⻋企内存在多个业务的系统，数据统计不聚合，缺少全局数据可视化看板，竞争对⼿的</section>
            <section>营销动向、⾏业热点收集困难；⽆法甄别优秀内容，运营转化效果不理想</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">可视化数据看板：</span>基于内容，对接多个内部系统，持续跟踪内容数据，组合分析不同维</section>
            <section>度的内容数据，形成数据看板</section>
            <section><span>数据监测回流：</span>监测竞品账号，洞察竞争对⼿内容数据，形成竞品数据看板。聚集⾏业</section>
            <section>热点内容排⾏，紧跟⾏业趋势；对⽐企业和竞品内容数据，优化⾃身内容营销⽅案，提</section>
            <section>升转化率</section>
            <section><span>内容数据运营：</span>从数据分析→⽤户分层→设计运营策略→创作优秀内容→触达⽬标群体</section>
            <section>→回收效果数据→以数据为指导优化策略，不断提⾼转化效果。实现更精准、更智能、</section>
            <section>更个性化的触达，促进转化</section>
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'finance',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/car/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }
     
    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
</style>